import { SearchSource } from '@carvana/merch-contracts';
import { X } from 'lucide-react';
import { useContext, useState } from 'react';
import Chip from '@/common/Chip';
import useRemoveFilterTag from '@/srp/MainLayout/AppliedFilters/useRemoveFilterTag';
import FilterEvents from '~/constants/srp/events';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import SearchEventsDataContext from '~/context/srp/SearchEventsDataContext';
import type { FacetTag } from '~/contracts/common';
import toLowerKebabCase from '~/utilities/toLowerKebabCase';

type OwnProps = {
  filterTag: FacetTag;
};

export default function Tag({ filterTag }: OwnProps) {
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const removeTag = useRemoveFilterTag(filterTag);
  const [show, setShow] = useState(true);
  const trackEvent = useTrackEvent();

  return show ? (
    <Chip
      data-adobe-id={toLowerKebabCase(
        'remove-applied-filter',
        filterTag.facetKey
      )}
      data-testid="remove-applied-filter"
      data-analytics-id={null}
      testId="remove-applied-filter"
      key={filterTag.tagName}
      icon={<X size={16} className="shrink-0" />}
      onClick={() => {
        setSearchSource(SearchSource.TagRemoved);
        setShow(false);
        removeTag();
        trackEvent(FilterEvents.removedFilter, {
          item: 'applied tag',
          label: filterTag.facetKey,
          value: filterTag.tagName
        });
      }}
    >
      <span className="inline-block max-w-[150px] truncate sm:max-w-[200px]">
        {filterTag.tagName}
      </span>
    </Chip>
  ) : null;
}
